var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.361635 2.19101L6.07213 7.62117C6.19588 7.74121 6.3431 7.83649 6.50531 7.90151C6.66752 7.96652 6.8415 8 7.01722 8C7.19295 8 7.36693 7.96652 7.52914 7.90151C7.69135 7.83649 7.83857 7.74121 7.96232 7.62117L13.6063 2.19101C13.731 2.07195 13.83 1.93031 13.8976 1.77424C13.9652 1.61818 14 1.45078 14 1.28171C14 1.11265 13.9652 0.945251 13.8976 0.789186C13.83 0.633121 13.731 0.491475 13.6063 0.372417C13.3569 0.133886 13.0195 0 12.6678 0C12.3162 0 11.9788 0.133886 11.7294 0.372417L7.01722 4.90609L2.30507 0.372417C2.05713 0.135816 1.72249 0.00242949 1.37329 0.00101471C1.1981 4.00543e-05 1.02444 0.0323453 0.862259 0.0960789C0.700079 0.159812 0.552569 0.25372 0.42819 0.372417C0.298972 0.487191 0.194674 0.625463 0.12132 0.779243C0.047966 0.933024 0.00701237 1.09927 0.000823975 1.26836C-0.00536537 1.43746 0.0233355 1.60606 0.0852652 1.76442C0.147195 1.92279 0.241127 2.06778 0.361635 2.19101Z",
    fill: "#676A71"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.171fedf135bbd74e68ee8d9021af203a.svg";
export { ForwardRef as ReactComponent };